import { UMA_AUTH_STORAGE_KEY } from '@oneview/api';
import { apiConfig } from '@oneview/config';
import { isProduction } from '@oneview/utils/branchUtils';
import { AesMidasApi } from '@orbis-systems/orbis-api-clients/aesmidas';
import { MiddlewareApi } from '@orbis-systems/orbis-api-clients/middleware';
import { OrbisApi } from '@orbis-systems/orbis-api-clients/orbis';
import { UmaApi } from '@orbis-systems/orbis-api-clients/uma';
import { InsightApi } from '@orbis-systems/orbis-api-clients/insight';
import { QueryClient } from '@tanstack/react-query';
import { cloneDeep } from 'lodash';

const MIDAS_API_URL = `${apiConfig.umaApiUrl}/../../aes/api`;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 0.5, // 30 seconds
        },
    },
});

export const orbis = new OrbisApi({
    debug: !isProduction(),
    baseUrl: apiConfig.apiUrl,
    authDataStorageKey: 'auth:orbis',
    storage: sessionStorage,
});

export const middleware = new MiddlewareApi({
    debug: !isProduction(),
    baseUrl: apiConfig.middlewareUrl,
    authDataStorageKey: 'auth:middleware',
    storage: sessionStorage,
});

export const uma = new UmaApi({
    debug: !isProduction(),
    baseUrl: apiConfig.umaApiUrl,
    authDataStorageKey: UMA_AUTH_STORAGE_KEY,
    storage: sessionStorage,
    firmId: String(apiConfig.umaFirmId),
    authFormSlug: apiConfig.umaAuthFormSlug,
});

export const aesmidas = new AesMidasApi({
    debug: !isProduction(),
    baseUrl: MIDAS_API_URL,
    authDataStorageKey: UMA_AUTH_STORAGE_KEY,
    storage: sessionStorage,
    onRenewToken: () => uma.renewToken(),
});

const insightConfig = cloneDeep(middleware.getApiClient().getConfig());
insightConfig.baseUrl += '/v1/insight';

export const insight = new InsightApi(insightConfig);
